import { Box, Button, Input, MenuItem, Select, SelectChangeEvent, Stack } from "@mui/material";
import { GLItemDTO, GLItemKind, GLItemKinds, GLItemStatus, GLItemStatuses } from "../../../DTO/GLItemDTO";
import InputB from "../../../components/InputB/InputB";
import { useEffect, useState } from "react";
import { DisplayDateTimeFromString } from "../../../services/DateTime";
import mainservice from "../../../services/MainService";
import { ArrowRight, Delete } from "@mui/icons-material";
import { TagSelector } from "../tags/TagSelector";
import { TagDTO, TagType } from "../../DTO/TagDTO";
import { X } from "react-feather";

enum Status {
    idle,
    saving,
    deleted,
}

export default function LogChatMsg({
    item,
    saveStart,
    saveCB,
    onClickDetail,
}: {
    item: GLItemDTO,
    saveStart?: () => void,
    saveCB: () => void,
    onClickDetail?: (id: number) => void,
}) {
    //const [content, setContent] = useState(item.content)
    const [glitem, setglitem] = useState(item)
    const [status, setStatus] = useState(Status.idle)
    async function save(val: string) {
        if (saveStart) { saveStart() }
        glitem.content = val
        await glitem.save(true)
        saveCB()
    }
    useEffect(() => {
        setglitem(item)
    }, [item])
    if (status === Status.deleted) {
        return null
    }
    return <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'stretch',
            border: '1px solid grey',
            borderRadius: 1,
            padding: 1
        }}
    >
        <Stack
            direction='row'
            spacing={2}
            sx={{
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            <Stack
                direction='row'
                spacing={2}
                sx={{
                    paddingBottom: 1,
                    alignItems: 'center',
                }}
            >
                {
                    glitem.created &&
                    <Box
                        title="Erstellt am"
                    >
                        {DisplayDateTimeFromString(glitem.created || '')}
                    </Box>
                }
                {
                    glitem.person &&
                    <Box
                        title={glitem.person.getDisplayName()}
                    >
                        <Button
                            onClick={() => {
                                mainservice.navTo([['view', 'spPersonEdit'], ['id', glitem.person?.id || -1]])
                            }}
                        >
                            {glitem.person.getDisplayName()}
                        </Button>
                    </Box>
                }
                {
                    glitem.person?.customerName &&
                    <Box
                        title={glitem.person.customerName}
                    >
                        <Button
                            onClick={() => {
                                mainservice.navTo([['view', 'spCustomerEdit'], ['id', glitem.person?.customerId || -1]])
                            }}
                        >
                            {glitem.person.customerName}
                        </Button>
                    </Box>
                }
            </Stack>
            <Stack
                direction='row'
            >
                <InputB
                    value={glitem.headline}
                    returnVal={async (value: string) => {
                        glitem.headline = value
                        await glitem.save()
                    }}
                />
            </Stack>
            <Stack
                direction='row'
                spacing={2}
                sx={{
                    paddingBottom: 1,
                    alignItems: 'center',
                }}
            >
                <Box
                    title="Autor"
                >
                    {glitem.author?.name || ''}
                </Box>
                {
                    glitem.showDelete() &&
                    <Button
                        color="error"
                        onClick={async () => {
                            const deleted = await glitem.delete()
                            if (deleted) {
                                setStatus(Status.deleted)
                            }
                        }}
                    >   
                        <Delete />
                    </Button>
                }
                {
                    glitem.kind !== undefined && GLItemStatuses[glitem.kind].length > 0 &&
                    <Select
                        value={glitem.status}
                        onChange={async (e) => {
                            setStatus(Status.saving)
                            glitem.status = Number(e.target.value)
                            if (glitem.id === -1) {
                                setTimeout(async () => {
                                    setStatus(Status.idle)
                                }, 500);
                            } else {
                                await glitem.save()
                                setStatus(Status.idle)
                            }
                        }}
                        label="Status"
                    >
                        {
                            GLItemStatuses[glitem.kind].map(s => {
                                return <MenuItem value={`${s.status}`} key={`message-${glitem.id}-status-${s.status}`}>
                                    {s.name}
                                </MenuItem>
                            })
                        }
                    </Select>
                }
                {
                    (!glitem.parentId || glitem.parentId === -1)  &&
                    <Select
                        value={glitem.kind}
                        onChange={async (e) => {
                            setStatus(Status.saving)
                            glitem.status = GLItemStatus.generic
                            glitem.kind = Number(e.target.value)
                            if (glitem.id === -1) {
                                setTimeout(async () => {
                                    setStatus(Status.idle)
                                }, 500);
                            } else {
                                await glitem.save()
                                setStatus(Status.idle)
                            }
                        }}
                        label="Art"
                    >
                        {
                            GLItemKinds.map(k => {
                                if (glitem.showKindOption(k.id) === false) { return null }
                                return <MenuItem value={`${k.id}`} key={`message-${glitem.id}-kindId-${k.id}`}>
                                    {k.name}
                                </MenuItem>
                            })
                        }
                    </Select>
                }
                {
                    onClickDetail &&
                    <Button
                        variant="contained"
                        endIcon={<ArrowRight />}
                        onClick={() => {
                            onClickDetail!(glitem.id)
                        }}
                    >
                        Details { glitem.childrenCount > -1 ? ` (${glitem.childrenCount})` : ''}
                    </Button>
                }
            </Stack>
        </Stack>
        {
            glitem.person &&
            <Stack
                direction='row'
                spacing={2}      
            >
                { // Tags
                    [
                    {
                        kind: 'FUNKTIONHOMOGEN',
                        mode: 'single'
                    },
                    {
                        kind: 'ABTEILUNGHOMOGEN',
                        mode: 'single'
                    },
                    {
                        kind: 'marketingRole',
                        mode: 'list'
                    },
                    {
                        kind: 'groupInfo',
                        mode: 'list'
                    },
                    {
                        kind: 'sales_origin',
                        mode: 'single'
                    },
                    ].map((t, index) => <Box
                        key={`person-tag-selector-${item.id}-${glitem.person?.id}-${t.kind}`}
                    >
                    <TagSelector
                        parentId={item.id}
                        kind={t.kind as TagType}
                        mode={t.mode as 'list' | 'single'}
                        selectedTags={glitem.person!.getTagsByKind(t.kind as TagType, 'tag')}
                        selectTag={async (tag: TagDTO, single: boolean) => {
                          await glitem.person!.setTag(tag, true);
                        }}
                        unsetTag={async (tag: TagDTO) => {
                          await glitem.person!.unsetTag(tag);
                        }}
                        readMode={false}
                    />
                    </Box>
                    )
                }
            </Stack>
        }
        {
            glitem.kind === GLItemKind.marketing &&
            <>
                <Stack
                    direction='row'
                    spacing={2}
                    sx={{
                        paddingTop: 1,
                        paddingBottom: 1,
                    }}
                >
                    <Stack
                        direction='column'
                        spacing={1}
                    >
                        <label>Potenzial [€]:</label>
                        <InputB
                            value={`${glitem.revenue_potential || '-'}`}
                            returnVal={async (value: string) => {
                                setStatus(Status.saving)
                                await glitem.setRevenuePotential(parseFloat(value))
                                setStatus(Status.idle)
                            }}
                        />
                    </Stack>
                    <Stack
                        direction='column'
                        spacing={1}
                    >
                        <label>Wahrscheinlichkeit [%]:</label>
                        <InputB
                            value={`${glitem.revenue_probability || '-'}`}
                            returnVal={async (value: string) => {
                                setStatus(Status.saving)
                                await glitem.setRevenueProbability(parseFloat(value))
                                setStatus(Status.idle)
                            }}
                        />
                    </Stack>
                    <Stack
                        direction='column'
                        spacing={1}
                    >
                        <label>gewichtetes Potenzial [€]:</label>
                        <Input disabled value={`${glitem.weighted_revenue || '-'}`} />
                    </Stack>
                    
                </Stack>
                <Stack
                    direction='column'
                    spacing={1}
                    sx={{
                        paddingBottom: 2,
                    }}
                >
                    <label>Quartal:</label>
                    <Stack
                        direction='row'
                        spacing={1}
                    >
                        <Select
                            value={glitem.getQuarter().quarter}
                            onChange={async (e: SelectChangeEvent<string>) => {
                                const {
                                    target: { value },
                                } = e
                                setStatus(Status.saving)
                                console.log('value ey!', value, e)
                                await glitem.setQuarter(value, glitem.getQuarter().year)
                                setStatus(Status.idle)
                            }}
                        >
                            {
                                glitem.getQuarters().map(q => {
                                    return <MenuItem value={`${q.id}`} key={`message-${glitem.id}-quarter-${q.id}`}>
                                        {q.id}
                                    </MenuItem>
                                })
                            }
                        </Select>
                        <InputB
                            value={`${glitem.getQuarter().year}`}
                            returnVal={async (value: string) => {
                                setStatus(Status.saving)
                                await glitem.setQuarter(glitem.getQuarter().quarter, parseInt(value))
                                setStatus(Status.idle)
                            }}
                        />
                        <Button
                            variant="outlined"
                            onClick={async () => {
                                setStatus(Status.saving)
                                await glitem.setQuarter('none', new Date().getFullYear())
                                setStatus(Status.idle)
                            }}
                        >
                            <X />
                        </Button>
                    </Stack>
                    
                </Stack>
            </>
        }
        <InputB
            returnVal={save}
            type={'wysiwyg'}
            value={glitem.content}
        />
    </Box>
}
